<template>
  <div><slot></slot></div>
</template>

<script>
  export default {
    name: 'WrapSlot'
  }
</script>

<style scoped>

</style>